import React from "react"
import { bem } from "../../helpers"
import PropTypes from "prop-types"
import BaseField from "../Field/Base";
import { EditorState, convertToRaw } from 'draft-js';
import { Editor as BaseEditor } from "react-draft-wysiwyg";
import draftToHtml from 'draftjs-to-html';
import "./Editor.scss";

export class Editor extends BaseField {
  inputType="editor"
  
  constructor(props) {
    super(props);
    this.state = {
      editorState: EditorState.createEmpty(),
    };
  }
  
  onChange = (editorState) => {
    this.setState({
      editorState,
    }, () => {
      if (this.props && this.props.onChange) {
        this.props.onChange({[this.props.id]: draftToHtml(convertToRaw(editorState.getCurrentContent()))})
      }
    })
  }

  renderInput = () => {
    return (
        <BaseEditor
          editorState={this.state.editorState}
          wrapperClassName={bem("editor")}
          toolbarClassName={bem("editor", "toolbar", [])}
          editorClassName={bem("editor", "input", [])}
          onEditorStateChange={this.onChange}
          {...this.props}
        />
    )
  }
}

// Editor.propTypes = {
//   ...BaseField.propTypes
// }

// Editor.defaultProps = BaseField.defaultProps

export default Editor
